module.exports = __webpack_public_path__ + "img/Sarah.83dd4f81.png";